import { render, staticRenderFns } from "./FTBotAPIPairList.vue?vue&type=template&id=0128fb4b&scoped=true&"
import script from "./FTBotAPIPairList.vue?vue&type=script&lang=ts&"
export * from "./FTBotAPIPairList.vue?vue&type=script&lang=ts&"
import style0 from "./FTBotAPIPairList.vue?vue&type=style&index=0&id=0128fb4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0128fb4b",
  null
  
)

export default component.exports